import React from 'react'

import Button from 'components/button'
import { openViewSettings } from 'components/spreadsheet/helpers/view-settings-bus'

const EmptyState: React.FC = () => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-3 p-8 text-center bg-surface">
      <div className="text-lg font-medium text-body-soft">Select a label and start date column to get started</div>
      <Button internalType="primary" onClick={() => openViewSettings('table-chart-button')}>
        Open calendar settings
      </Button>
    </div>
  )
}

export default EmptyState
